// extracted by mini-css-extract-plugin
export default {"load-more-trigger":"UbOawz3q3NuE+LN+eA1z2g=="};